import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Link, useFetcher, useNavigate, useParams } from "react-router-dom";
import { CourseSidebarLecture } from "../types/lectureTypes";

interface NextLectureProps {
  isCompleted: boolean | null;
  nextLecture: CourseSidebarLecture | null;
  courseProgress: number | null;
}

export function NextLectureButton({
  courseProgress,
  isCompleted,
  nextLecture,
}: NextLectureProps) {
  const { t } = useTranslation();
  const { courseId, lectureId } = useParams();
  if (!courseId || !lectureId) {
    throw Error(t("lecture.errors.tryAgain"));
  }

  const navigate = useNavigate();
  const fetcher = useFetcher();
  const handleComplete = () => {
    if (!isCompleted)
      fetcher.submit(
        { lectureId: lectureId, intent: "mark-complete" },
        { method: "post" },
      );

    if (nextLecture) return navigate(`/course/${courseId}/${nextLecture.id}`);
    navigate(`/certificates`);
  };

  // 1. Tamamlanmamış ve sonraki ders var
  if (!isCompleted && nextLecture) {
    return (
      <Button onClick={handleComplete}>
        {t("lecture.navigation.completeAndNext")}
      </Button>
    );
  }
  // 2. Tamamlanmış ve sonraki ders var
  if (isCompleted && nextLecture) {
    return (
      <Link to={`/course/${courseId}/${nextLecture.id}`}>
        <Button>{t("lecture.navigation.nextLecture")}</Button>
      </Link>
    );
  }
  // 3. Tamamlanmamış ve son ders
  if (!isCompleted && !nextLecture) {
    if (courseProgress && courseProgress > 90)
      return (
        <Button onClick={handleComplete}>
          {t("lecture.navigation.completeAndGetCertificate")}
        </Button>
      );
    return <span></span>;
  }
  if (courseProgress && courseProgress > 90)
    return (
      <Button onClick={handleComplete}>
        {t("lecture.navigation.getCertificate")}
      </Button>
    );
  return <span></span>;
}
